import React from 'react';
import { COLOR } from '../../styles';
import { type SVGProps } from './SVG.types';

export const Speedometer: React.FC<SVGProps> = ({
  color = COLOR['white'],
  height = '56px',
  width = '88px',
}) => (
  <svg
    className="icon icon-speedometer"
    width={width}
    height={height}
    viewBox="0 0 88 56"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g fill={color} fillRule="nonzero">
      <path d="M52.173,41.876 C52.145,41.547 52.051,41.218 51.887,40.905 L31.254,1.971 C30.645,0.827 29.271,0.287 28.025,0.704 C26.777,1.127 26.032,2.378 26.269,3.654 L34.31,46.827 C34.373,47.17 34.506,47.477 34.687,47.757 C34.765,48.126 34.86,48.493 34.987,48.861 C36.282,52.555 39.825,55.045 43.8,55.045 C44.827,55.045 45.848,54.879 46.824,54.548 C49.178,53.756 51.077,52.11 52.171,49.912 C53.266,47.714 53.422,45.232 52.615,42.918 C52.492,42.555 52.34,42.21 52.173,41.876 Z M43.803,3.533 C42.332,3.533 41.141,4.703 41.141,6.146 C41.141,7.589 42.332,8.76 43.803,8.76 C65.021,8.76 82.279,25.721 82.279,46.566 C82.279,48.008 83.474,49.179 84.943,49.179 C86.416,49.179 87.607,48.008 87.607,46.566 C87.605,22.834 67.956,3.533 43.803,3.533 Z M16.276,13.087 C5.933,21.306 0,33.507 0,46.565 C0,48.008 1.191,49.18 2.663,49.18 C4.137,49.18 5.328,48.008 5.328,46.565 C5.328,35.095 10.539,24.376 19.626,17.156 C20.772,16.248 20.946,14.6 20.023,13.477 C19.1,12.355 17.423,12.179 16.276,13.087 Z"></path>
    </g>
  </svg>
);

// Display Name
Speedometer.displayName = 'Speedometer';

export default Speedometer;
